import { 
	Datagrid, 
	List, 
	TextField, 
	DateField, 
	BooleanField, 
	NumberField,
	EditButton,
	ShowButton
} from 'react-admin';

const DatingEventList = () => (
	<List title="אירועי דייטינג" resource="dating-events">
		<Datagrid rowClick="edit" style={{ textAlign: 'right' }}>
			<TextField source="title" label="כותרת עברית" textAlign="right" dir="rtl" />
			<TextField source="title_english" label="כותרת אנגלית" textAlign="right" dir="ltr" />
			<TextField source="description.he" label="תיאור" textAlign="right" dir="rtl" />
			<TextField source="time" label="תאריך ושעה" />
			<TextField source="address" label="כתובת" textAlign="right" dir="rtl" />
			<NumberField source="limitInvatations" label="מספר הזמנות מקסימלי" />
			<BooleanField source="isActive" label="פעיל" />
			<DateField source="createdAt" label="נוצר בתאריך" />
			<EditButton />
			<ShowButton />
		</Datagrid>
	</List>
);

export default DatingEventList;
